export const proxyToRaw = new WeakMap();
export const rawToProxy = new WeakMap();
